import {
  withObservables,
  ExtractedObservables,
} from "@nozbe/watermelondb/react";
import Sale from "../../../../../../utilities/data/model/Sale";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { SelectablePaymentMethodButton } from "../SelectablePaymentMethodButton";
import { useThemeProvider, Divider } from "@towersystems/roam-common-native";

const getObservables = ({ sale }: { sale: Sale }) => ({
  customer: sale?.customer.observe(),
});

export interface CustomerInvoiceOptionsRendererProps
  extends ExtractedObservables<ReturnType<typeof getObservables>> {
  sale: Sale;
  onPress?: () => void;
}

export const CustomerInvoiceOptionsRenderer = ({
  sale,
  customer,
  onPress,
}: CustomerInvoiceOptionsRendererProps) => {
  const { colors } = useThemeProvider();

  const canInvoiceCustomerAccount = sale.isInvoice
    ? true
    : customer &&
      customer.isRetailerCusAccount &&
      sale.payments.length === 0 &&
      sale.isSale;

  const customerInvoiceMarkup = canInvoiceCustomerAccount ? (
    <>
      <Divider marginVertical={0} />
      <SelectablePaymentMethodButton
        onPress={() => onPress?.()}
        label="Invoice"
        description={`Invoice customer account.`}
        disabled={!canInvoiceCustomerAccount}
        icon={
          <MaterialCommunityIcons
            name="credit-card-clock-outline"
            color={colors.text}
            size={26}
          />
        }
      />
    </>
  ) : null;

  return customerInvoiceMarkup;
};

const enhance = withObservables(["sale"], getObservables);

export const CustomerInvoiceOptions = enhance(CustomerInvoiceOptionsRenderer);
